import { type ServiceAddress } from './service-address';
import { type PhoneInfo } from './phone-info';
import { type ContactPhoneInfo } from './contact-phone-info';
import { type ContactEmailInfo } from './contact-email-info';
import { type BillInfo } from './bill-info';
import { type BillingPeriod } from './billing-period';
import { type RecentPayment } from './recent-payment';
import { type PaymentHistory } from './payment-history';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { type PaymentMethod } from './payment-method';
import { type PaymentPlan } from './payment-plan';
import { type FuturePayment } from './future-payment';
import { type AutoPay } from './auto-pay';
import { type BillingRate } from './billing-rate';
import { type Person } from './person';

export class AccountDetail {
  public AccountNumber: string = '';
  public AutoPay?: AutoPay;
  public CurrentBalance?: number;
  public CurrentBalanceDueDate?: Date;
  public ServiceAddresses: ServiceAddress[] = [];
  public ServiceAddressCount: number = 0;
  public IsRenewalInProgress?: boolean;
  public DefaultAddress?: ServiceAddress;
  public BillingAddress?: ServiceAddress;
  public PhoneNumbers?: PhoneInfo[];
  public ContactPhoneInfo?: ContactPhoneInfo[];
  public ContactEmailInfo?: ContactEmailInfo[];
  public BillRate?: BillingRate;
  public Bills?: BillInfo[];
  public BillURL?: string;
  public FinalBillDate?: Date;
  public FinalBillDueDate?: Date;
  public FirstBillDate?: Date;
  public IsAutoPay?: boolean;
  public IsFinalBill?: boolean;
  public IsInCollections?: boolean;
  public IsLimitedPaymentOptions?: boolean;
  public LandLordAlertIndicator?: string;
  public AccountBridgePlanStatus?: string;
  public PrimaryAccountHolder?: boolean;
  public IsPaperlessBilling?: boolean;
  public IsStopped?: boolean;
  public IsPaymentAllowed?: boolean;
  public IsSevered?: boolean;
  public IQSScore?: string;
  public MinimumPayment?: number;
  public MostRecentBillPeriod?: BillingPeriod;
  public MostRecentPayment?: RecentPayment;
  public NextBillDate?: Date;
  public NextBillDueDate?: Date;
  public PastDueBalance?: number;
  public Payments?: PaymentHistory[];
  public ServiceStartDate?: Date;
  public ShowRenewal?: boolean;
  public BudgetAmount?: number;
  public ReferFriendCode: string = '';
  public IsOnePricePlan?: boolean;
  public IsBudgetBillEligible?: boolean;
  public FirstName?: string;
  public LastName?: string;
  public Email?: string;
  public PersonId?: string;
  public CustomerClass?: string;
  public SaRateScheduleCode?: string;
  public SuppressBillingRateIndicator?: string;
  public BillingRateExpirationDate?: Date;
  public PaymentPlans?: PaymentPlan[];
  public IsEligibleForPayPlan: boolean = false;
  public PayPlanEligibilityMessage?: string;
  public PayPlanAmount?: number;
  public PayPlanDueDate?: string;
  public IsPayPlan?: boolean;
  public PayPlanType?: string;
  public PaymentMethods?: PaymentMethod[];
  public PastCutoffTime?: Date; // This will be value in CMS
  public IsEligibleForFuturePayment?: boolean;
  public FuturePayment?: FuturePayment | null;
  public Person?: Person;
  public HeadlineCode?: string;
  public Error?: any;
  public GCMANameMatch?: string = '';
  public EligibileForRateChange: boolean = false;
  public EligibileForRenewal: boolean = false;
}
